<template>
  <div class="main_box">
    <h2 class="hidden-md-and-up">用户管理</h2>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span class="condition_item_lable">关键字：</span>
            <el-input
              v-model="userInfoQuery.KeyWord"
              placeholder="姓名/手机号/用户名"
              clearable
            ></el-input>
          </div>
          <div class="condition_item">
            <span class="condition_item_lable">角色：</span>
            <el-select
              v-model="userInfoQuery.RoleId"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="userRole in userRoles"
                :key="userRole.RoleID"
                :label="userRole.RoleName"
                :value="userRole.RoleID"
              ></el-option>
            </el-select>
          </div>
          <div class="condition_item">
            <el-button type="primary" @click="search()">查询</el-button>
            <el-button @click="refresh()" size="small" plain> 刷新 </el-button>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="primary" @click="openEditUser(null)">
            新增用户
          </el-button>
          <el-button type="primary" @click="deleteUsers()">
            批量删除
          </el-button>
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <el-table
          :data="userInfoList.Items"
          highlight-current-row
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column label="姓名" width="180" align="left" key="UserName">
            <template slot-scope="scope">
              <span>{{ scope.row.UserName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="角色"
            min-width="150"
            align="left"
            key="RoleNameText"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.RoleNameText }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="企业编码"
            min-width="180"
            align="left"
            key="CompanyOrgCode"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.CompanyOrgCode }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="用户名"
            width="130"
            align="center"
            key="LoginName"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.LoginName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="手机号"
            width="120"
            align="center"
            key="MobilePhone"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.MobilePhone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                type="primary"
                title="设置角色"
                class="cell_link"
                @click="openEeditUserRole(scope.row)"
                v-if="!scope.row.IsCurrentUser"
              >
                <i class="iconfont icon-shezhijiaose"></i>
              </el-link>
              <el-link
                type="primary"
                title="重置密码"
                class="cell_link"
                @click="resetUserPwd(scope.row)"
              >
                <i class="iconfont icon-zhongzhimima"></i>
              </el-link>
              <el-link
                type="primary"
                title="编辑"
                class="cell_link"
                @click="openEditUser(scope.row.UserID)"
              >
                <i class="iconfont icon-bian-ji"></i>
              </el-link>
              <el-link
                type="primary"
                title="删除"
                class="cell_link"
                @click.stop
                @click="deleteUser(scope.row)"
                v-if="!scope.row.IsCurrentUser"
              >
                <i class="iconfont icon-shanchu"></i>
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="userInfoQuery.MaxResultCount"
            :page-sizes="[10, 20, 30, 50]"
            :layout="pagination_layout"
            :total="userInfoList.TotalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="this.userForm.UserId === null ? '新增用户' : '编辑用户'"
      :visible.sync="editUserDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
      @close="editUserDialogClose"
    >
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form
            :model="userForm"
            :rules="userFormRules"
            ref="userForm"
            label-width="120px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="姓名：" prop="UserName">
              <el-input
                v-model="userForm.UserName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名：" prop="LoginName">
              <el-input
                v-model="userForm.LoginName"
                autocomplete="off"
                :disabled="this.userForm.UserId"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="MobilePhone">
              <el-input
                v-model="userForm.MobilePhone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUser()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="设置角色"
      :visible.sync="editUserRoleDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <el-table
        :data="userRoles"
        ref="userRolesTable"
        highlight-current-row
        :label-position="is_xs ? 'top' : 'left'"
        :show-header="false"
        @selection-change="userRolesSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="" align="left" key="RoleName">
          <template slot-scope="scope">
            <span>{{ scope.row.RoleName }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editUserRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserRole()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    const phoneReg = /^1[0-9]{10}$/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      userRoles: [],
      userInfoQuery: {
        KeyWord: null,
        RoleId: null,
        MaxResultCount: 10,
        SkipCount: 0
      },
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      userInfoList: {},
      multipleSelection: [],
      editUserDialogVisible: false,
      userForm: {
        UserId: null,
        UserName: null,
        LoginName: null,
        MobilePhone: null
      },
      userFormRules: {
        UserName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 100, message: '姓名过长！', trigger: 'blur' }],
        LoginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 100, message: '用户名过长！', trigger: 'blur' }],
        MobilePhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }]
      },
      editUserRoleDialogVisible: false,
      multipleSelectRoles: [],
      userSelectRole: {
        UserId: null,
        RoleIds: []
      }
    }
  },
  methods: {
    indexMethod (index) {
      return this.userInfoQuery.SkipCount + index + 1
    },
    getRolesByNoSystem: function () {
      const _this = this
      _this.openLoading()
      _this.$api.role.getRolesByNoSystem().then(data => {
        _this.userRoles = data
        _this.getUserList()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getUserList: function () {
      const _this = this
      _this.openLoading()
      _this.$api.userInfo.getUserList(_this.userInfoQuery).then(data => {
        _this.userInfoList = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    refresh: function () {
      this.getUserList()
    },
    search: function () {
      this.getUserList()
    },
    handleSizeChange (val) {
      this.userInfoQuery.MaxResultCount = val
      this.getUserList()
    },
    handleCurrentChange (val) {
      this.userInfoQuery.SkipCount = (val - 1) * this.userInfoQuery.MaxResultCount
      this.getUserList()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    openEditUser: function (userId) {
      const _this = this
      _this.editUserDialogVisible = true
      _this.userForm.UserId = userId
      if (userId) {
        const editLoading = this.openLoading()
        _this.$api.userInfo.getUserInfo({ userId: userId }).then(data => {
          _this.userForm = data
          editLoading.close()
        }).catch(err => {
          editLoading.close()
          return err
        })
      } else {
        _this.userForm.UserName = null
        _this.userForm.LoginName = null
        _this.userForm.MobilePhone = null
      }
    },
    editUser: function () {
      const _this = this
      _this.$refs.userForm.validate((valid) => {
        if (valid) {
          const editLoading = this.openLoading()
          _this.$api.userInfo.editUserInfo(_this.userForm).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！',
              customClass: 'custom_message'
            })
            _this.editUserDialogVisible = false
            _this.getUserList()
          }).catch(err => {
            editLoading.close()
            _this.editUserDialogVisible = false
            return err
          })
        } else {
          return false
        }
      })
    },
    editUserDialogClose: function (done) {
      const _this = this
      _this.$refs.userForm.clearValidate()
    },
    deleteUser: function (row) {
      const _this = this
      _this.$confirm('确定要删除用户“' + row.UserName + '”吗？', '提示-删除用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        const editLoading = _this.openLoading()
        _this.$api.userInfo.deleteUser({ userId: row.UserID }).then(data => {
          _this.getUserList()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '用户已删除！',
            customClass: 'custom_message'
          })
          editLoading.close()
        }).catch(err => {
          editLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    deleteUsers: function () {
      const _this = this
      if (this.multipleSelection.length === 0) {
        _this.$message({
          showClose: true,
          type: 'warning',
          message: '未选择要删除的用户！',
          customClass: 'custom_message'
        })
        return
      }
      _this.$confirm('确定要删除选中的用户吗？', '提示-删除用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        const deleteUserIds = []
        this.multipleSelection.forEach(function (selectionItem, index) {
          deleteUserIds.push(selectionItem.UserID)
        })
        const editLoading = _this.openLoading()
        _this.$api.userInfo.batchDeleteUsers(deleteUserIds).then(data => {
          _this.getUserList()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '用户已删除！',
            customClass: 'custom_message'
          })
          editLoading.close()
        }).catch(err => {
          editLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    resetUserPwd: function (row) {
      const _this = this
      _this.$confirm('确定要将用户“' + row.UserName + '”密码重置为888888吗？', '提示-重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        const editLoading = _this.openLoading()
        _this.$api.userInfo.resetUserPwd({ UserId: row.UserID }).then(data => {
          _this.$message({
            showClose: true,
            type: 'success',
            message: '密码已重置！',
            customClass: 'custom_message'
          })
          editLoading.close()
        }).catch(err => {
          editLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          showClose: true,
          type: 'info',
          message: '已取消重置密码',
          customClass: 'custom_message'
        })
      })
    },
    openEeditUserRole: function (row) {
      const _this = this
      _this.editUserRoleDialogVisible = true
      _this.userSelectRole.UserId = row.UserID
      const editLoading = _this.openLoading()
      _this.$api.userInfo.getUserRoleIds({ userId: row.UserID }).then(userRoleIds => {
        this.$nextTick(() => {
          _this.userRoles.forEach(function (roleItem, index) {
            _this.$refs.userRolesTable.toggleRowSelection(roleItem, false)
            userRoleIds.forEach(function (userRoleId, index) {
              if (roleItem.RoleID.toLowerCase() === userRoleId.toLowerCase()) {
                _this.$refs.userRolesTable.toggleRowSelection(roleItem, true)
              }
            })
          })
        })
        editLoading.close()
      }).catch(err => {
        editLoading.close()
        return err
      })
    },
    editUserRole: function (row) {
      const _this = this
      const editLoading = _this.openLoading()
      _this.userSelectRole.RoleIds = []
      this.multipleSelectRoles.forEach(function (selectionItem, index) {
        _this.userSelectRole.RoleIds.push(selectionItem.RoleID)
      })
      _this.$api.userInfo.editUserRole(_this.userSelectRole).then(data => {
        _this.$message({
          showClose: true,
          type: 'success',
          message: '设置成功！',
          customClass: 'custom_message'
        })
        _this.editUserRoleDialogVisible = false
        editLoading.close()
        _this.getUserList()
      }).catch(err => {
        editLoading.close()
        return err
      })
    },
    userRolesSelectionChange (val) {
      this.multipleSelectRoles = val
    }
  },
  created () {
    this.getRolesByNoSystem()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
